module.exports = __webpack_public_path__ + "media/imagine_you_and_me.96623fd2.mp3";